// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { Button } from "@revvsales/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cameraBlock from "../../assets/Camera-block-img-3c.png";
// Comonents Imports
// import { Button } from "../../commonComponents";

// import StatusDropdown from "../QuotationTopbar/StatusDropdown";

class AllowCameraPopup extends Component {
  _onClose = () => {
    this.props.updateMultipleState({
      showEmailMessage: false,
      showAllowCameraPopup: false,
    });
  };

  render() {
    return (
      <Modal open onClose={this._onClose} closeOnOverlayClick={false} center>
        <div className="allow-camera-popup">
          {/* ----------- Modal Heading Section ----------- */}
          <div className="modal-heading" data-test="allowcamera-modal-heading">
            Camera and microphone are blocked
          </div>
          <div className="allowcamera-modal-body">
            <div>
              <FontAwesomeIcon
                icon={["fas", "video"]}
                size="3x"
                color="#909090"
              />
              <FontAwesomeIcon
                icon={["fas", "microphone"]}
                size="3x"
                color="#909090"
              />
            </div>
            <div>
              Revv requires access to your camera and microphone. Click the
              camera blocked icon in your address bar and allow access{" "}
            </div>
            <img src={cameraBlock} alt="camera-block" />
            <Button
              id="allowcamera-close-btn"
              type="two"
              data-test="allowcamera-close-btn"
              onClick={this._onClose}>
              Got it
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default AllowCameraPopup;



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/AllowCameraPopup.js